__turbopack_context__.v({
  "className": "nunito_c494f784-module__7vh0PG__className",
  "variable": "nunito_c494f784-module__7vh0PG__variable",
});
